var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagFr({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 139 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31987_87259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.21 0H0V92H46.21V0Z",
    fill: "#01209F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.42 0H46.21V92H92.42V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.63 0H92.42V92H138.63V0Z",
    fill: "#EF4234"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31987_87259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138.63,
    height: 92.42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagFr);
export default __webpack_public_path__ + "static/media/Flag_FR.b2dcddcf5d6325057192c862778ede1c.svg";
export { ForwardRef as ReactComponent };